export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoicmV2ZXJuZW50IiwiYSI6ImNrdm00dHg4dzB2bDEycW91NjlhMW9scXUifQ.UZ-O__5TVetSFeNYw8qBSw";

export const MAPBOX_STYLE =
  "mapbox://styles/revernent/ckvkpf2150rb515p2g4h22tx9";

const START_POINT = {
  lng: 127.0016985,
  lat: 37.5642135,
};

const ZOOM_LEVEL_ALL = {
  default: 7,
  max: 16,
  min: 7,
};

const ZOOM_LEVEL = {
  default: 11,
  max: 16,
  min: 8,
};

const ZOOM_LEVEL_BIG = {
  default: 16,
  max: 18,
  min: 14,
};

export const MAPBOX_OPTION = {
  style: MAPBOX_STYLE,
  center: [128.15902, 36.4109664],
  zoom: ZOOM_LEVEL_ALL.default,
  maxZoom: ZOOM_LEVEL_ALL.max,
  minZoom: ZOOM_LEVEL_ALL.min,
  attributionControl: false,
};

export const MAPBOX_OPTION_ZOOMBIG = {
  style: MAPBOX_STYLE,
  zoom: ZOOM_LEVEL_BIG.default,
  maxZoom: ZOOM_LEVEL_BIG.max,
  minZoom: ZOOM_LEVEL_BIG.min,
  attributionControl: false,
  scrollZoom: false,
};

export const MAPBOX_OPTION_PARKING = {
  style: "mapbox://styles/revernent/ckwaf6z4f2u2f14lc4tzmv5od",
  center: [START_POINT.lng, START_POINT.lat],
  zoom: ZOOM_LEVEL.default,
  maxZoom: ZOOM_LEVEL.max,
  minZoom: ZOOM_LEVEL.min,
  attributionControl: false,
};

//=====================================================
// Image
//=====================================================
export const IMAGE_INFO = {
  cover: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-cover2.png",
    alt: "커버 이미지",
  },
  title: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-title.png",
    alt: "제목 위 이미지",
  },
  subtitle: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-subtitle3.png",
    alt: "중간제목 이미지",
  },
  leftman1: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-leftman3.png",
    alt: "멘트 이미지",
  },
  rightman1: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-rightman3.png",
    alt: "멘트 이미지",
  },
  leftman2: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-leftman2.png",
    alt: "멘트 이미지",
  },
  parking: {
    src: "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-pmparking.png",
    alt: "기사 이미지",
  },
};
